import Styles from '../DesignMarketplaceWizard.module.scss'
import { Button } from 'blaze-ui/Button'
import { useModals } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { DesignChannel } from 'components/NewFileModal/Types'
import { VisualElement, VisualElementsClient } from 'api/clients/VisualElementClient'
import { useVisualElementsCounts } from 'hooks/queries/visualElements/useVisualElementsCounts'
import { sum } from 'lodash'
import { TemplatesModalV2 } from 'components/Templates/TemplatesModalV2/TemplatesModalV2'
import { IFilters } from 'components/Templates/TemplatesModalV2/Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { TextFieldLoadingState } from '../../TextFieldLoadingState/TextFieldLoadingState'
import { BrandKitField } from '../../Wizard/Form/BrandKitField/BrandKitField'

interface Props {
  width: number
  height: number
  filters: Omit<IFilters, 'aspectRatioKey'>
  channel: DesignChannel
  onTemplateSelect: (template?: VisualElement) => void
  setTemplateFromModal: (template?: VisualElement) => void
}

export const Actions = ({ width, height, onTemplateSelect, channel, filters, setTemplateFromModal }: Props) => {
  const { isMobile } = useResponsiveDesign()
  const { openModal, closeStack } = useModals()

  const { data } = useVisualElementsCounts(
    { ...filters, width, height },
    {
      staleTime: Infinity,
    },
  )
  const totalCount = data ? sum(Object.values(data)) : 0

  const handleOpenModal = () => {
    openModal(
      TemplatesModalV2,
      {
        width,
        height,
        designChannel: channel,
        onUse: async (templateId: number) => {
          const { data: template } = await VisualElementsClient.getElement(templateId)
          onTemplateSelect(template)
          setTemplateFromModal(template)
          closeStack()
        },
      },
      { newStack: true },
    )
  }

  return (
    <div className={Styles.actionsContainer}>
      {!totalCount ? (
        <div className={Styles.loadingButton}>
          <TextFieldLoadingState fixedHeight={isMobile ? 40 : 32} />
        </div>
      ) : (
        <Button
          size={isMobile ? 'lg' : 'sm'}
          fullWidth={isMobile}
          variant={isMobile ? 'tertiary' : 'secondary'}
          onPress={handleOpenModal}
        >
          See All Templates
        </Button>
      )}
      {!isMobile && (
        <div className={Styles.brandKitInput}>
          <Text variant="secondary" color="var(--dark-40)">
            Brand Kit
          </Text>
          <BrandKitField size="xs" />
        </div>
      )}
    </div>
  )
}
